(function () {
  var section = document.getElementById('influencers');
  var root = section && section.closest('.shopify-section');
  if (!root || root.dataset.interactionsReady) return;
  root.dataset.interactionsReady = 'true';
  root.classList.add('tw-home-interactive');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  root.querySelectorAll('.tw-home-explore a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'start'});
      history.replaceState(null,'',link.hash);
      target.setAttribute('tabindex','-1');target.focus({preventScroll:true});
      if (!reduced.matches) target.animate([{boxShadow:'inset 0 0 0 3px #b89459'},{boxShadow:'inset 0 0 0 0px transparent'}],{duration:1300});
    });
  });
  var seen = new WeakSet();
  var observer = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (!reduced.matches && entry.target.animate) {
        var siblings = Array.from(entry.target.parentElement.children);
        var delay = Math.min(siblings.indexOf(entry.target) % 4, 3) * 100;
        entry.target.animate([{opacity:0,transform:'translateY(44px) scale(.96)'},{opacity:1,transform:'translateY(0) scale(1)'}],{duration:720,delay:delay,fill:'backwards',easing:'cubic-bezier(.16,1,.3,1)'});
      }
    });
  }, {threshold:.08}) : null;
  function watch(scope) {
    if (!observer || reduced.matches) return;
    scope.querySelectorAll('.sh,.inf-card,.dc,.hero__c,.tw-home-explore a,.ct,.quote-strip,.nb,.hs').forEach(function (node) {
      if (seen.has(node)) return;
      seen.add(node);observer.observe(node);
    });
  }
  watch(root);
  var pending = false;
  var mutations = new MutationObserver(function (entries) {
    if (pending || !entries.some(function (entry) {return Array.from(entry.addedNodes).some(function (node) {return node.nodeType === 1;});})) return;
    pending = true;
    requestAnimationFrame(function () {pending = false;watch(root);});
  });
  mutations.observe(root,{childList:true,subtree:true});
  var top = document.createElement('button');
  top.type = 'button';top.className = 'tw-home-top';top.textContent = '↑ 맨 위로';top.hidden = true;
  top.setAttribute('aria-label','페이지 맨 위로 이동');
  document.body.appendChild(top);
  var progress = document.createElement('div');
  progress.className = 'tw-home-progress';progress.setAttribute('aria-hidden','true');
  document.body.appendChild(progress);
  var scrollPending = false;
  function update() {
    top.hidden = window.scrollY < 650;
    var total = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.transform = 'scaleX(' + (total > 0 ? Math.min(1,Math.max(0,window.scrollY / total)) : 0) + ')';
    scrollPending = false;
  }
  window.addEventListener('scroll',function () {if (!scrollPending) {scrollPending=true;requestAnimationFrame(update);}}, {passive:true});
  top.addEventListener('click',function () {
    window.scrollTo({top:0,behavior:reduced.matches?'instant':'smooth'});
    var heading = root.querySelector('h1');
    if (heading) {heading.setAttribute('tabindex','-1');heading.focus({preventScroll:true});}
  });
  reduced.addEventListener('change',function () {
    if (reduced.matches) root.getAnimations({subtree:true}).forEach(function (animation) {animation.cancel();});
    else watch(root);
  });
  update();
})();
